import { EditorConfigType } from '../editor';
import { child, button, section } from '../editor/dsl';

export const BtnBaseConfig = (hasClickHandler = false) =>
  child(EditorConfigType.Sidebar)
    .title('Button')
    .sections(section('Button').forms(button(undefined, hasClickHandler)));
